// DS: i4.13
import React from 'react';
import IconWrap from '../../IconWrap';
const Clock = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 4a1 1 0 00-.993.883L11 7v6a1 1 0 00.883.993L12 14h6a1 1 0 00.117-1.993L18 12l-5-.001V7a1 1 0 00-1-1z"
    })));
Clock.displayName = 'Clock';
export default Clock;
